module.exports = __webpack_public_path__ + "files/1096ebc7dc5f4ed7a04a73b50e4f5e94.png";